<script setup>
// currentRefinement, range, refine, canRefine

import Slider from "primevue/slider";
import { defineProps, ref, watch } from "vue";
import { getSliderPt } from "../style.js";

const props = defineProps({
  currentRefinement: {
    type: Object,
  },
  range: {
    type: Object,
  },
  refine: {
    type: Function,
  },
  canRefine: {
    type: Boolean,
  },
});

const localSlider = ref([props.range.min, props.range.max]);

watch(
  () => props.currentRefinement,
  ({ min, max }) => {
    // only override handles if Algolia has actually refined
    if (min != null) {
      if (min < props.range.min) {
        localSlider.value[0] = props.range.min;
      } else localSlider.value = [min, localSlider.value[1]];
    }
    if (max != null) {
      if (max > props.range.max) {
        localSlider.value[1] = props.range.max;
      } else localSlider.value = [localSlider.value[0], max];
    }
  },
  { immediate: true },
);

watch(
  () => props.range,
  ({ min, max }) => {
    localSlider.value = [min, max];
  },
  { immediate: true },
);
</script>

<template>
  <div v-if="canRefine" class="p-2">
    <Slider
      v-model="localSlider"
      :min="range.min"
      :max="range.max"
      :disabled="!canRefine"
      range
      :step="1"
      :pt="getSliderPt()"
      @slideend="({ value }) => refine({ min: value[0], max: value[1] })"
    />
    <div v-if="canRefine" class="mt-2 text-sm">
      {{ currentRefinement.min || range.min }} - {{ currentRefinement.max || range.max }}
    </div>
  </div>
  <div v-else class="text-xs bg-gray-75 text-indigo-base rounded-md mt-1">
    <p>No options available. Clear a filter on another category.</p>
  </div>
</template>
